import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = {
  key: 0,
  class: "pwd-input-wrap"
}
const _hoisted_3 = {
  key: 1,
  class: "btn-wrap"
}
const _hoisted_4 = {
  key: 2,
  class: "pwd-input-wrap"
}
const _hoisted_5 = {
  key: 3,
  class: "btn-wrap"
}

import { ref, onMounted } from 'vue';
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { showToast } from 'vant';
import { useRouter, useRoute } from 'vue-router';
import { realNameAuth } from '@/api/system';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();

const title = ref('设置支付密码')

const data = ref<any>(null);
const payPassword = ref('');
const confirmPassword = ref('');
const showKeyboard = ref(false);
const showConfirmKeyboard = ref(false);
const showConfirmInput = ref(false);

// 输入处理
const onInput = (key: string) => {
  if (payPassword.value.length < 6) {
    payPassword.value = payPassword.value + key;
  }
};

// 确认密码输入处理
const onConfirmInput = (key: string) => {
  if (confirmPassword.value.length < 6) {
    confirmPassword.value = confirmPassword.value + key;
  }
};

// 删除处理
const onDelete = () => {
  if (payPassword.value.length > 0) {
    payPassword.value = payPassword.value.slice(0, -1);
  }
};

// 确认密码删除处理
const onConfirmDelete = () => {
  if (confirmPassword.value.length > 0) {
    confirmPassword.value = confirmPassword.value.slice(0, -1);
  }
};

// 提交处理
const onSubmit = async () => {
  if (payPassword.value !== confirmPassword.value) {
    showToast({
      type: 'fail',
      message: '两次输入的密码不一致'
    });
    return;
  }

  try {
    // 这里添加设置支付密码的API调用
    await realNameAuth({
      idCard: data.value.idCard,
      payPassword: payPassword.value,
      phoneNumber: data.value.phoneNumber,
      realName: data.value.realName
    }).then(res => {
      console.log(res)
      if (res.code === 200) {
        showToast({
          type: 'success',
          message: '设置支付密码成功'
        });
        // 设置密码成功后，回到上一层，并刷新用户信息
        store.dispatch('user/refreshUserInfo');
        router.back();
      } else {
        showToast({
          type: 'fail',
          message: res.msg
        });
      }
    });

  } catch (error) {
    showToast({
      type: 'fail',
      message: '设置失败,请重试'
    });
  }
};

onMounted(() => {
  if (route.query.data) {
    data.value = JSON.parse(route.query.data as string)
    console.log(data.value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_van_password_input = _resolveComponent("van-password-input")!
  const _component_van_number_keyboard = _resolveComponent("van-number-keyboard")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, { title: title.value }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      (!showConfirmInput.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "tip-text" }, "请设置支付密码,用于支付验证", -1)),
            _createVNode(_component_van_password_input, {
              value: payPassword.value,
              focused: showKeyboard.value,
              length: 6,
              onFocus: _cache[0] || (_cache[0] = ($event: any) => (showKeyboard.value = true))
            }, null, 8, ["value", "focused"]),
            _createVNode(_component_van_number_keyboard, {
              show: showKeyboard.value,
              "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showKeyboard).value = $event)),
              onInput: onInput,
              onDelete: onDelete,
              maxlength: 6,
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (showKeyboard.value = false))
            }, null, 8, ["show"])
          ]))
        : _createCommentVNode("", true),
      (!showConfirmInput.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_van_button, {
              type: "primary",
              round: "",
              disabled: payPassword.value.length !== 6,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showConfirmInput.value = true))
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode(" 继续 ")
              ])),
              _: 1
            }, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true),
      (showConfirmInput.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "tip-text" }, "请再次填写支付密码以确认", -1)),
            _createVNode(_component_van_password_input, {
              value: confirmPassword.value,
              focused: showConfirmKeyboard.value,
              length: 6,
              onFocus: _cache[4] || (_cache[4] = ($event: any) => (showConfirmKeyboard.value = true))
            }, null, 8, ["value", "focused"]),
            _createVNode(_component_van_number_keyboard, {
              show: showConfirmKeyboard.value,
              "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((showConfirmKeyboard).value = $event)),
              onInput: onConfirmInput,
              onDelete: onConfirmDelete,
              maxlength: 6,
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (showConfirmKeyboard.value = false))
            }, null, 8, ["show"])
          ]))
        : _createCommentVNode("", true),
      (showConfirmInput.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_van_button, {
              type: "primary",
              round: "",
              disabled: confirmPassword.value.length !== 6,
              onClick: onSubmit
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode(" 确认 ")
              ])),
              _: 1
            }, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})